/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AiRouteImport } from './routes/ai'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as IntegrationsRouteImport } from './routes/integrations'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as PasswordResetRouteImport } from './routes/password-reset'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as SalesRouteImport } from './routes/sales'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as WaitingRouteImport } from './routes/waiting'
import { Route as AiIndexRouteImport } from './routes/ai.index'
import { Route as AiGapsRouteImport } from './routes/ai.gaps'
import { Route as AiHandoffRouteImport } from './routes/ai.handoff'
import { Route as AiKnowledgeRouteImport } from './routes/ai.knowledge'
import { Route as AiStatusRouteImport } from './routes/ai.status'
import { Route as AiTestChatRouteImport } from './routes/ai.test-chat'
import { Route as AiUsageRouteImport } from './routes/ai.usage'
import { Route as AiVoiceRouteImport } from './routes/ai.voice'
import { Route as ContentIndexRouteImport } from './routes/content.index'
import { Route as ContentContentIdRouteImport } from './routes/content.$contentId'
import { Route as InboxIndexRouteImport } from './routes/inbox.index'
import { Route as InboxConversationIdRouteImport } from './routes/inbox.$conversationId'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding.index'
import { Route as OnboardingStepRouteImport } from './routes/onboarding.$step'
import { Route as ProductsIndexRouteImport } from './routes/products.index'
import { Route as ProductsProductIdRouteImport } from './routes/products.$productId'
import { Route as ReportsIndexRouteImport } from './routes/reports.index'
import { Route as ReportsReportIdRouteImport } from './routes/reports.$reportId'
import { Route as SalesIndexRouteImport } from './routes/sales.index'
import { Route as SalesOpportunitiesRouteImport } from './routes/sales.opportunities'
import { Route as SalesSalesRouteImport } from './routes/sales.sales'
import { Route as SalesSummaryRouteImport } from './routes/sales.summary'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsAccountRouteImport } from './routes/settings.account'
import { Route as SettingsBillingRouteImport } from './routes/settings.billing'
import { Route as SettingsBusinessRouteImport } from './routes/settings.business'
import { Route as SettingsNotificationsRouteImport } from './routes/settings.notifications'
import { Route as SettingsUsersRouteImport } from './routes/settings.users'
import { Route as ShoppersIndexRouteImport } from './routes/shoppers.index'
import { Route as ShoppersShopperIdRouteImport } from './routes/shoppers.$shopperId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AiRoute = AiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsRoute = IntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetRoute = PasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesRoute = SalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const WaitingRoute = WaitingRouteImport.update({
  id: '/waiting',
  path: '/waiting',
  getParentRoute: () => rootRouteImport,
} as any)
const AiIndexRoute = AiIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AiRoute,
} as any)
const AiGapsRoute = AiGapsRouteImport.update({
  id: '/gaps',
  path: '/gaps',
  getParentRoute: () => AiRoute,
} as any)
const AiHandoffRoute = AiHandoffRouteImport.update({
  id: '/handoff',
  path: '/handoff',
  getParentRoute: () => AiRoute,
} as any)
const AiKnowledgeRoute = AiKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => AiRoute,
} as any)
const AiStatusRoute = AiStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => AiRoute,
} as any)
const AiTestChatRoute = AiTestChatRouteImport.update({
  id: '/test-chat',
  path: '/test-chat',
  getParentRoute: () => AiRoute,
} as any)
const AiUsageRoute = AiUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AiRoute,
} as any)
const AiVoiceRoute = AiVoiceRouteImport.update({
  id: '/voice',
  path: '/voice',
  getParentRoute: () => AiRoute,
} as any)
const ContentIndexRoute = ContentIndexRouteImport.update({
  id: '/content/',
  path: '/content/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentContentIdRoute = ContentContentIdRouteImport.update({
  id: '/content/$contentId',
  path: '/content/$contentId',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxIndexRoute = InboxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InboxRoute,
} as any)
const InboxConversationIdRoute = InboxConversationIdRouteImport.update({
  id: '/$conversationId',
  path: '/$conversationId',
  getParentRoute: () => InboxRoute,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingStepRoute = OnboardingStepRouteImport.update({
  id: '/onboarding/$step',
  path: '/onboarding/$step',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsProductIdRoute = ProductsProductIdRouteImport.update({
  id: '/products/$productId',
  path: '/products/$productId',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReportsRoute,
} as any)
const ReportsReportIdRoute = ReportsReportIdRouteImport.update({
  id: '/$reportId',
  path: '/$reportId',
  getParentRoute: () => ReportsRoute,
} as any)
const SalesIndexRoute = SalesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SalesRoute,
} as any)
const SalesOpportunitiesRoute = SalesOpportunitiesRouteImport.update({
  id: '/opportunities',
  path: '/opportunities',
  getParentRoute: () => SalesRoute,
} as any)
const SalesSalesRoute = SalesSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => SalesRoute,
} as any)
const SalesSummaryRoute = SalesSummaryRouteImport.update({
  id: '/summary',
  path: '/summary',
  getParentRoute: () => SalesRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBillingRoute = SettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBusinessRoute = SettingsBusinessRouteImport.update({
  id: '/business',
  path: '/business',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => SettingsRoute,
} as any)
const ShoppersIndexRoute = ShoppersIndexRouteImport.update({
  id: '/shoppers/',
  path: '/shoppers/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShoppersShopperIdRoute = ShoppersShopperIdRouteImport.update({
  id: '/shoppers/$shopperId',
  path: '/shoppers/$shopperId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ai': typeof AiRouteWithChildren
  '/inbox': typeof InboxRouteWithChildren
  '/integrations': typeof IntegrationsRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/password-reset': typeof PasswordResetRoute
  '/reports': typeof ReportsRouteWithChildren
  '/sales': typeof SalesRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/waiting': typeof WaitingRoute
  '/ai/gaps': typeof AiGapsRoute
  '/ai/handoff': typeof AiHandoffRoute
  '/ai/knowledge': typeof AiKnowledgeRoute
  '/ai/status': typeof AiStatusRoute
  '/ai/test-chat': typeof AiTestChatRoute
  '/ai/usage': typeof AiUsageRoute
  '/ai/voice': typeof AiVoiceRoute
  '/content/$contentId': typeof ContentContentIdRoute
  '/inbox/$conversationId': typeof InboxConversationIdRoute
  '/onboarding/$step': typeof OnboardingStepRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/reports/$reportId': typeof ReportsReportIdRoute
  '/sales/opportunities': typeof SalesOpportunitiesRoute
  '/sales/sales': typeof SalesSalesRoute
  '/sales/summary': typeof SalesSummaryRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/business': typeof SettingsBusinessRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/shoppers/$shopperId': typeof ShoppersShopperIdRoute
  '/ai/': typeof AiIndexRoute
  '/content/': typeof ContentIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/sales/': typeof SalesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/shoppers/': typeof ShoppersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/integrations': typeof IntegrationsRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/password-reset': typeof PasswordResetRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/waiting': typeof WaitingRoute
  '/ai/gaps': typeof AiGapsRoute
  '/ai/handoff': typeof AiHandoffRoute
  '/ai/knowledge': typeof AiKnowledgeRoute
  '/ai/status': typeof AiStatusRoute
  '/ai/test-chat': typeof AiTestChatRoute
  '/ai/usage': typeof AiUsageRoute
  '/ai/voice': typeof AiVoiceRoute
  '/content/$contentId': typeof ContentContentIdRoute
  '/inbox/$conversationId': typeof InboxConversationIdRoute
  '/onboarding/$step': typeof OnboardingStepRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/reports/$reportId': typeof ReportsReportIdRoute
  '/sales/opportunities': typeof SalesOpportunitiesRoute
  '/sales/sales': typeof SalesSalesRoute
  '/sales/summary': typeof SalesSummaryRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/business': typeof SettingsBusinessRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/shoppers/$shopperId': typeof ShoppersShopperIdRoute
  '/ai': typeof AiIndexRoute
  '/content': typeof ContentIndexRoute
  '/inbox': typeof InboxIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/products': typeof ProductsIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/sales': typeof SalesIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/shoppers': typeof ShoppersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ai': typeof AiRouteWithChildren
  '/inbox': typeof InboxRouteWithChildren
  '/integrations': typeof IntegrationsRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/password-reset': typeof PasswordResetRoute
  '/reports': typeof ReportsRouteWithChildren
  '/sales': typeof SalesRouteWithChildren
  '/settings': typeof SettingsRouteWithChildren
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/waiting': typeof WaitingRoute
  '/ai/gaps': typeof AiGapsRoute
  '/ai/handoff': typeof AiHandoffRoute
  '/ai/knowledge': typeof AiKnowledgeRoute
  '/ai/status': typeof AiStatusRoute
  '/ai/test-chat': typeof AiTestChatRoute
  '/ai/usage': typeof AiUsageRoute
  '/ai/voice': typeof AiVoiceRoute
  '/content/$contentId': typeof ContentContentIdRoute
  '/inbox/$conversationId': typeof InboxConversationIdRoute
  '/onboarding/$step': typeof OnboardingStepRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/reports/$reportId': typeof ReportsReportIdRoute
  '/sales/opportunities': typeof SalesOpportunitiesRoute
  '/sales/sales': typeof SalesSalesRoute
  '/sales/summary': typeof SalesSummaryRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/billing': typeof SettingsBillingRoute
  '/settings/business': typeof SettingsBusinessRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/shoppers/$shopperId': typeof ShoppersShopperIdRoute
  '/ai/': typeof AiIndexRoute
  '/content/': typeof ContentIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/sales/': typeof SalesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/shoppers/': typeof ShoppersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ai'
    | '/inbox'
    | '/integrations'
    | '/login'
    | '/notifications'
    | '/password-reset'
    | '/reports'
    | '/sales'
    | '/settings'
    | '/signup'
    | '/verify-email'
    | '/waiting'
    | '/ai/gaps'
    | '/ai/handoff'
    | '/ai/knowledge'
    | '/ai/status'
    | '/ai/test-chat'
    | '/ai/usage'
    | '/ai/voice'
    | '/content/$contentId'
    | '/inbox/$conversationId'
    | '/onboarding/$step'
    | '/products/$productId'
    | '/reports/$reportId'
    | '/sales/opportunities'
    | '/sales/sales'
    | '/sales/summary'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/business'
    | '/settings/notifications'
    | '/settings/users'
    | '/shoppers/$shopperId'
    | '/ai/'
    | '/content/'
    | '/inbox/'
    | '/onboarding/'
    | '/products/'
    | '/reports/'
    | '/sales/'
    | '/settings/'
    | '/shoppers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/integrations'
    | '/login'
    | '/notifications'
    | '/password-reset'
    | '/signup'
    | '/verify-email'
    | '/waiting'
    | '/ai/gaps'
    | '/ai/handoff'
    | '/ai/knowledge'
    | '/ai/status'
    | '/ai/test-chat'
    | '/ai/usage'
    | '/ai/voice'
    | '/content/$contentId'
    | '/inbox/$conversationId'
    | '/onboarding/$step'
    | '/products/$productId'
    | '/reports/$reportId'
    | '/sales/opportunities'
    | '/sales/sales'
    | '/sales/summary'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/business'
    | '/settings/notifications'
    | '/settings/users'
    | '/shoppers/$shopperId'
    | '/ai'
    | '/content'
    | '/inbox'
    | '/onboarding'
    | '/products'
    | '/reports'
    | '/sales'
    | '/settings'
    | '/shoppers'
  id:
    | '__root__'
    | '/'
    | '/ai'
    | '/inbox'
    | '/integrations'
    | '/login'
    | '/notifications'
    | '/password-reset'
    | '/reports'
    | '/sales'
    | '/settings'
    | '/signup'
    | '/verify-email'
    | '/waiting'
    | '/ai/gaps'
    | '/ai/handoff'
    | '/ai/knowledge'
    | '/ai/status'
    | '/ai/test-chat'
    | '/ai/usage'
    | '/ai/voice'
    | '/content/$contentId'
    | '/inbox/$conversationId'
    | '/onboarding/$step'
    | '/products/$productId'
    | '/reports/$reportId'
    | '/sales/opportunities'
    | '/sales/sales'
    | '/sales/summary'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/business'
    | '/settings/notifications'
    | '/settings/users'
    | '/shoppers/$shopperId'
    | '/ai/'
    | '/content/'
    | '/inbox/'
    | '/onboarding/'
    | '/products/'
    | '/reports/'
    | '/sales/'
    | '/settings/'
    | '/shoppers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiRoute: typeof AiRouteWithChildren
  InboxRoute: typeof InboxRouteWithChildren
  IntegrationsRoute: typeof IntegrationsRoute
  LoginRoute: typeof LoginRoute
  NotificationsRoute: typeof NotificationsRoute
  PasswordResetRoute: typeof PasswordResetRoute
  ReportsRoute: typeof ReportsRouteWithChildren
  SalesRoute: typeof SalesRouteWithChildren
  SettingsRoute: typeof SettingsRouteWithChildren
  SignupRoute: typeof SignupRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  WaitingRoute: typeof WaitingRoute
  ContentContentIdRoute: typeof ContentContentIdRoute
  OnboardingStepRoute: typeof OnboardingStepRoute
  ProductsProductIdRoute: typeof ProductsProductIdRoute
  ShoppersShopperIdRoute: typeof ShoppersShopperIdRoute
  ContentIndexRoute: typeof ContentIndexRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
  ShoppersIndexRoute: typeof ShoppersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai': {
      id: '/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations': {
      id: '/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset': {
      id: '/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales': {
      id: '/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof SalesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/waiting': {
      id: '/waiting'
      path: '/waiting'
      fullPath: '/waiting'
      preLoaderRoute: typeof WaitingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai/': {
      id: '/ai/'
      path: '/'
      fullPath: '/ai/'
      preLoaderRoute: typeof AiIndexRouteImport
      parentRoute: typeof AiRoute
    }
    '/ai/gaps': {
      id: '/ai/gaps'
      path: '/gaps'
      fullPath: '/ai/gaps'
      preLoaderRoute: typeof AiGapsRouteImport
      parentRoute: typeof AiRoute
    }
    '/ai/handoff': {
      id: '/ai/handoff'
      path: '/handoff'
      fullPath: '/ai/handoff'
      preLoaderRoute: typeof AiHandoffRouteImport
      parentRoute: typeof AiRoute
    }
    '/ai/knowledge': {
      id: '/ai/knowledge'
      path: '/knowledge'
      fullPath: '/ai/knowledge'
      preLoaderRoute: typeof AiKnowledgeRouteImport
      parentRoute: typeof AiRoute
    }
    '/ai/status': {
      id: '/ai/status'
      path: '/status'
      fullPath: '/ai/status'
      preLoaderRoute: typeof AiStatusRouteImport
      parentRoute: typeof AiRoute
    }
    '/ai/test-chat': {
      id: '/ai/test-chat'
      path: '/test-chat'
      fullPath: '/ai/test-chat'
      preLoaderRoute: typeof AiTestChatRouteImport
      parentRoute: typeof AiRoute
    }
    '/ai/usage': {
      id: '/ai/usage'
      path: '/usage'
      fullPath: '/ai/usage'
      preLoaderRoute: typeof AiUsageRouteImport
      parentRoute: typeof AiRoute
    }
    '/ai/voice': {
      id: '/ai/voice'
      path: '/voice'
      fullPath: '/ai/voice'
      preLoaderRoute: typeof AiVoiceRouteImport
      parentRoute: typeof AiRoute
    }
    '/content/': {
      id: '/content/'
      path: '/content'
      fullPath: '/content/'
      preLoaderRoute: typeof ContentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/content/$contentId': {
      id: '/content/$contentId'
      path: '/content/$contentId'
      fullPath: '/content/$contentId'
      preLoaderRoute: typeof ContentContentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/': {
      id: '/inbox/'
      path: '/'
      fullPath: '/inbox/'
      preLoaderRoute: typeof InboxIndexRouteImport
      parentRoute: typeof InboxRoute
    }
    '/inbox/$conversationId': {
      id: '/inbox/$conversationId'
      path: '/$conversationId'
      fullPath: '/inbox/$conversationId'
      preLoaderRoute: typeof InboxConversationIdRouteImport
      parentRoute: typeof InboxRoute
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/$step': {
      id: '/onboarding/$step'
      path: '/onboarding/$step'
      fullPath: '/onboarding/$step'
      preLoaderRoute: typeof OnboardingStepRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/': {
      id: '/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/$productId': {
      id: '/products/$productId'
      path: '/products/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof ProductsProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/reports/$reportId': {
      id: '/reports/$reportId'
      path: '/$reportId'
      fullPath: '/reports/$reportId'
      preLoaderRoute: typeof ReportsReportIdRouteImport
      parentRoute: typeof ReportsRoute
    }
    '/sales/': {
      id: '/sales/'
      path: '/'
      fullPath: '/sales/'
      preLoaderRoute: typeof SalesIndexRouteImport
      parentRoute: typeof SalesRoute
    }
    '/sales/opportunities': {
      id: '/sales/opportunities'
      path: '/opportunities'
      fullPath: '/sales/opportunities'
      preLoaderRoute: typeof SalesOpportunitiesRouteImport
      parentRoute: typeof SalesRoute
    }
    '/sales/sales': {
      id: '/sales/sales'
      path: '/sales'
      fullPath: '/sales/sales'
      preLoaderRoute: typeof SalesSalesRouteImport
      parentRoute: typeof SalesRoute
    }
    '/sales/summary': {
      id: '/sales/summary'
      path: '/summary'
      fullPath: '/sales/summary'
      preLoaderRoute: typeof SalesSummaryRouteImport
      parentRoute: typeof SalesRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/billing': {
      id: '/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof SettingsBillingRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/business': {
      id: '/settings/business'
      path: '/business'
      fullPath: '/settings/business'
      preLoaderRoute: typeof SettingsBusinessRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/users': {
      id: '/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/shoppers/': {
      id: '/shoppers/'
      path: '/shoppers'
      fullPath: '/shoppers/'
      preLoaderRoute: typeof ShoppersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shoppers/$shopperId': {
      id: '/shoppers/$shopperId'
      path: '/shoppers/$shopperId'
      fullPath: '/shoppers/$shopperId'
      preLoaderRoute: typeof ShoppersShopperIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AiRouteChildren {
  AiGapsRoute: typeof AiGapsRoute
  AiHandoffRoute: typeof AiHandoffRoute
  AiKnowledgeRoute: typeof AiKnowledgeRoute
  AiStatusRoute: typeof AiStatusRoute
  AiTestChatRoute: typeof AiTestChatRoute
  AiUsageRoute: typeof AiUsageRoute
  AiVoiceRoute: typeof AiVoiceRoute
  AiIndexRoute: typeof AiIndexRoute
}

const AiRouteChildren: AiRouteChildren = {
  AiGapsRoute: AiGapsRoute,
  AiHandoffRoute: AiHandoffRoute,
  AiKnowledgeRoute: AiKnowledgeRoute,
  AiStatusRoute: AiStatusRoute,
  AiTestChatRoute: AiTestChatRoute,
  AiUsageRoute: AiUsageRoute,
  AiVoiceRoute: AiVoiceRoute,
  AiIndexRoute: AiIndexRoute,
}

const AiRouteWithChildren = AiRoute._addFileChildren(AiRouteChildren)

interface InboxRouteChildren {
  InboxConversationIdRoute: typeof InboxConversationIdRoute
  InboxIndexRoute: typeof InboxIndexRoute
}

const InboxRouteChildren: InboxRouteChildren = {
  InboxConversationIdRoute: InboxConversationIdRoute,
  InboxIndexRoute: InboxIndexRoute,
}

const InboxRouteWithChildren = InboxRoute._addFileChildren(InboxRouteChildren)

interface ReportsRouteChildren {
  ReportsReportIdRoute: typeof ReportsReportIdRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
}

const ReportsRouteChildren: ReportsRouteChildren = {
  ReportsReportIdRoute: ReportsReportIdRoute,
  ReportsIndexRoute: ReportsIndexRoute,
}

const ReportsRouteWithChildren =
  ReportsRoute._addFileChildren(ReportsRouteChildren)

interface SalesRouteChildren {
  SalesOpportunitiesRoute: typeof SalesOpportunitiesRoute
  SalesSalesRoute: typeof SalesSalesRoute
  SalesSummaryRoute: typeof SalesSummaryRoute
  SalesIndexRoute: typeof SalesIndexRoute
}

const SalesRouteChildren: SalesRouteChildren = {
  SalesOpportunitiesRoute: SalesOpportunitiesRoute,
  SalesSalesRoute: SalesSalesRoute,
  SalesSummaryRoute: SalesSummaryRoute,
  SalesIndexRoute: SalesIndexRoute,
}

const SalesRouteWithChildren = SalesRoute._addFileChildren(SalesRouteChildren)

interface SettingsRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsBillingRoute: typeof SettingsBillingRoute
  SettingsBusinessRoute: typeof SettingsBusinessRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsUsersRoute: typeof SettingsUsersRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsBillingRoute: SettingsBillingRoute,
  SettingsBusinessRoute: SettingsBusinessRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsUsersRoute: SettingsUsersRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiRoute: AiRouteWithChildren,
  InboxRoute: InboxRouteWithChildren,
  IntegrationsRoute: IntegrationsRoute,
  LoginRoute: LoginRoute,
  NotificationsRoute: NotificationsRoute,
  PasswordResetRoute: PasswordResetRoute,
  ReportsRoute: ReportsRouteWithChildren,
  SalesRoute: SalesRouteWithChildren,
  SettingsRoute: SettingsRouteWithChildren,
  SignupRoute: SignupRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  WaitingRoute: WaitingRoute,
  ContentContentIdRoute: ContentContentIdRoute,
  OnboardingStepRoute: OnboardingStepRoute,
  ProductsProductIdRoute: ProductsProductIdRoute,
  ShoppersShopperIdRoute: ShoppersShopperIdRoute,
  ContentIndexRoute: ContentIndexRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  ProductsIndexRoute: ProductsIndexRoute,
  ShoppersIndexRoute: ShoppersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
